import React from 'react';
import { Box, VStack, Spinner, Heading, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const LoadingScreen: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box
      minH="100vh"
      bg="blue.50"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <VStack spacing={6} textAlign="center">
        {/* Hotel Logo Placeholder */}
        <Box
          w={20}
          h={20}
          bg="blue.600"
          borderRadius="xl"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <svg viewBox="0 0 24 24" width="40px" height="40px" color="white">
            <path
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 3h18l-1 7H4L3 3z M5 10v9a1 1 0 001 1h12a1 1 0 001-1v-9"
            />
          </svg>
        </Box>

        {/* Loading Spinner */}
        <Spinner size="xl" color="blue.600" />

        {/* Loading Text */}
        <VStack spacing={2}>
          <Heading size="lg" color="blue.900">
            {t('app.name')}
          </Heading>
          <Text color="blue.700">
            {t('app.tagline')}
          </Text>
        </VStack>
      </VStack>
    </Box>
  );
};

export default LoadingScreen;